import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError, change, untouch } from "redux-form";
import _ from "lodash";
import { Link } from "react-router";
import Title from "../../components/Layout/Title";
import { toastr } from "react-redux-toastr";

import MaskDate from "../../components/Util/MaskDate";
import { GAD_RS_LOAD, GAD_RS_UNLOAD, LOGOUT } from "../../actions/Constants";

import api from "../../api/apiUtil";
import ReactTable from "react-table";
import TextField from "../../components/Fields/TextField";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import TextareaField from "../../components/Fields/TextareaField";
import FieldValidation from "../../components/Validation/FieldValidation";
import MaskDecimal from "../../components/Util/MaskDecimal";

class GadRs extends React.Component {
  constructor() {
    super();
    this.state = {
      configurar: false,
    };
    document.addEventListener("keyup", this.keyDownHandler);
  }

  keyDownHandler = (event) => {
    if (event.keyCode === 13 && document.getElementById("filterDuda")) {
      document.getElementById("filterDuda").click();
    }
  };

  componentDidMount() {
    this.props.onGadRsLoad(api.GadRs.recuperaGadRs());
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.keyDownHandler);
    this.props.onGadRsUnload();
  }

  cadastrar = (values) => {
    const errors = {};
    if (!values.quantidade || values.quantidade.length === 0) {
      errors.quantidade = "Campo obrigatório";
    }
    if (errors && !_.isEmpty(errors)) {
      throw new SubmissionError(errors);
    } else {
      var props = this.props;
      Promise.resolve(api.GadRs.gerar({ quantidade: values.quantidade }))
        .then((ret) => {
          this.props.onGadRsLoad(api.GadRs.recuperaGadRs());
          this.clearForm();
          toastr.success("Sucesso", "GAD gerada com sucesso.");
        })
        .catch(function (resp) {
          if (resp.status === 403) {
            toastr.warning("Atenção", resp.response.body.message);
          } else if (resp === "Unauthorized" || resp === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
          }
        });
    }
  };

  recuperaNotificacao = async () => {
    try {
      const ret = await api.Configuracao.getPorAtributo("GAD_RS");
      if (ret) {
        this.props.dispatch(change("GadRsForm", "emailsNotificar", JSON.parse(ret.valor).emailsNotificar));
        this.props.dispatch(change("GadRsForm", "qtdNotificar", JSON.parse(ret.valor).qtdNotificar));
        this.setState({ configurar: !this.state.configurar });
      }
    } catch (resp) {
      this.handleNotificacaoError(resp);
    }
  };

  configurarNotif = async (values) => {
    try {
      const params = {
        valor: JSON.stringify({ emailsNotificar: values.emailsNotificar, qtdNotificar: values.qtdNotificar }),
        atributo: "GAD_RS",
      };
      await api.Configuracao.putConfig(params);
      this.setState({ configurar: !this.state.configurar });
      toastr.success("Sucesso", "Configuração de notificação alterada.");
    } catch (resp) {
      this.handleNotificacaoError(resp);
    }
  };

  handleNotificacaoError = (resp) => {
    if (resp.status === 403) {
      toastr.warning("Atenção", resp.response.body.message);
      return;
    }

    if (resp === "Unauthorized" || resp === "jwt expired") {
      api.Auth.logout();
      this.props.onLogout();
      return;
    }
    toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
  };

  clearForm = () => {
    this.props.dispatch(change("GadRsForm", "quantidade", null));
    this.props.dispatch(untouch("GadRsForm", "quantidade"));
  };

  render() {
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} />
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <form className="form-horizontal">
                <div className="hpanel">
                  <div className="panel-heading">
                    {this.props.currentUser.funcionalidades.includes(113) && !this.state.configurar && (
                      <Link className="btn btn-xs btn-info" onClick={() => this.recuperaNotificacao()}>
                        <i className="fas fa-book" /> Configurar Notificação
                      </Link>
                    )}
                    <div className="panel-tools"></div>
                    <br></br>
                  </div>
                  {this.props.currentUser.funcionalidades.includes(113) && (
                    <>
                      {this.state.configurar && (
                        <div className="panel-body">
                          <div className="row">
                            <div className="col-md-10">
                              <Field name="emailsNotificar" label="E-mails a serem notificados" component={TextareaField} type="text" rows={2} required validate={[FieldValidation.required]} />
                            </div>
                            <div className="col-md-2">
                              <Field
                                name="qtdNotificar"
                                label="Quantidade de Tarifas"
                                required={true}
                                component={TextField}
                                type="text"
                                normalize={FieldNormalize.NUMBER}
                                maxlength={3}
                                validate={[FieldValidation.required, FieldValidation.maxLength3]}
                                textTooltip="Quantidade mínima de tarifas disponíveis para enviar a notificação"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="text-right">
                                <Link className="btn btn-default" onClick={() => this.setState({ configurar: !this.state.configurar })}>
                                  {" "}
                                  Cancelar
                                </Link>
                                <button className="btn btn-success" type="button" onClick={this.props.handleSubmit(this.configurarNotif.bind(this))}>
                                  Salvar
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <br></br>
                      <div className="panel-body">
                        <div className="m-b-md">
                          <h5>Cadastrar Guia de Arrecadação Detran RS</h5>
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                            <Field
                              name="quantidade"
                              label="Quantidade de Tarifas"
                              component={TextField}
                              type="text"
                              maxlength={2}
                              required={true}
                              normalize={FieldNormalize.NUMBER}
                              validate={[FieldValidation.minValue2]}
                              textTooltip="Será gerada uma GAD (Guia de Arrecadação Detran) com a quantidade de tarifas informadas"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="text-right">
                              <button className="btn btn-success" type="button" onClick={this.props.handleSubmit(this.cadastrar.bind(this))}>
                                Cadastrar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="hpanel">
                  <div className="panel-body">
                    <div className="table-responsive">
                      <ReactTable
                        className="-striped -highlight"
                        defaultPageSize={20}
                        data={this.props.all}
                        loadingText="Carregando..."
                        noDataText="Nenhuma Informação encontrada"
                        rowsText="linhas"
                        showPageSizeOptions={false}
                        minRows={1}
                        showPagination={true}
                        previousText="Anterior"
                        nextText="Próximo"
                        pageText="página"
                        ofText="de"
                        columns={[
                          {
                            Header: "Data Geração",
                            accessor: "rowData",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 180,
                            Cell: (rowData) => {
                              return (
                                <div>
                                  <span>{rowData.original.dataGeracao ? MaskDate.TO_BR_DATETIME(rowData.original.dataGeracao) : "Não possuí"}</span>
                                  <br />
                                </div>
                              );
                            },
                          },
                          {
                            Header: "Qtd de Registros",
                            accessor: "qtdRegistros",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 140,
                          },
                          {
                            Header: "Qtd de Registros Utilizados",
                            accessor: "qtdUtilizados",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 200,
                          },
                          {
                            Header: "Linha Digitável",
                            accessor: "rowLinhaDig",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            Cell: (rowLinhaDig) => {
                              return (
                                <div>
                                  <span>{rowLinhaDig.original.linhaDigitavel ? rowLinhaDig.original.linhaDigitavel : "Não informada"}</span>
                                  <br />
                                </div>
                              );
                            },
                          },
                          {
                            Header: "Data Vencimento",
                            accessor: "rowDataVencimento",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 180,
                            Cell: (rowDataVencimento) => {
                              return (
                                <div>
                                  <span>{rowDataVencimento.original.dataVencimento ? MaskDate.TO_BR(rowDataVencimento.original.dataVencimento) : "Não possuí"}</span>
                                  <br />
                                </div>
                              );
                            },
                          },
                          {
                            Header: "Valor Total",
                            accessor: "rowValorTotal",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 140,
                            Cell: (rowValorTotal) => {
                              return (
                                <div>
                                  <span>{rowValorTotal.original.valorTotal ? MaskDecimal.TO_BRL(rowValorTotal.original.valorTotal) : "Não possuí"}</span>
                                  <br />
                                </div>
                              );
                            },
                          },
                          {
                            Header: "Status Envio Banco",
                            accessor: "statusEnvioBanco",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 150,
                            Cell: (statusEnvioBanco) => {
                              return (
                                <div>
                                  <span>
                                    {statusEnvioBanco.original.statusEnvioBanco
                                      ? statusEnvioBanco.original.statusEnvioBanco == 1
                                        ? "Enviado"
                                        : statusEnvioBanco.original.statusEnvioBanco == 2
                                        ? "Dados Inconsistentes"
                                        : statusEnvioBanco.original.statusEnvioBanco == 3
                                        ? "Dados Inconsistentes"
                                        : statusEnvioBanco.original.statusEnvioBanco == 4
                                        ? "Pendente de Autorização"
                                        : statusEnvioBanco.original.statusEnvioBanco == 5
                                        ? "Em Processamento"
                                        : statusEnvioBanco.original.statusEnvioBanco == 6
                                        ? "Processado"
                                        : statusEnvioBanco.original.statusEnvioBanco == 7
                                        ? "Rejeitado"
                                        : statusEnvioBanco.original.statusEnvioBanco == 8
                                        ? "Em Processamento"
                                        : statusEnvioBanco.original.statusEnvioBanco == 9
                                        ? "Em Processamento"
                                        : statusEnvioBanco.original.statusEnvioBanco == 10
                                        ? "Em Processamento"
                                        : ""
                                      : "Não possuí"}
                                  </span>
                                  <br />
                                </div>
                              );
                            },
                          },
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onGadRsLoad: (payload) => dispatch({ type: GAD_RS_LOAD, payload }),
  onGadRsUnload: (payload) => dispatch({ type: GAD_RS_UNLOAD, payload }),
  onLogout: () => dispatch({ type: LOGOUT }),
});

const mapStateToProps = (state) => ({
  ...state.gadRs,
  currentUser: state.common.currentUser,
});

const form = reduxForm({
  form: "GadRsForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(GadRs));
